// extracted by css-extract-rspack-plugin
export default {"cardViewContainer":"cardViewContainer-DOJWsw","cardItem":"cardItem-t0xUX6","cardItemLast":"cardItemLast-xYPZjJ"};